import { cva } from 'class-variance-authority';

export const tagVariants = cva(
  'inline-flex items-center gap-1 rounded-md border px-2 py-1 text-start text-base font-normal leading-relaxed transition-colors',
  {
    variants: {
      variant: {
        solid: 'border-none bg-background-secondary text-text-primary',
        default: 'border-outline bg-surface text-text-primary',
        primary: 'border-none bg-background-primary text-text-primary-invert',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);
